import React from "react";
import { BTN_CHIP, BTN_CHIP_ACTIVE } from "./reportingStyles";

const todayIsoDate = () => new Date().toISOString().slice(0, 10);
const yesterdayIsoDate = () => {
  const d = new Date();
  d.setDate(d.getDate() - 1);
  return d.toISOString().slice(0, 10);
};

function DateQuickPicker({ date, onChange }) {
  const today = todayIsoDate();
  const yesterday = yesterdayIsoDate();
  const isToday = date === today;
  const isYesterday = date === yesterday;

  return (
    <div className="daily-report-date-picker flex items-center gap-1 rounded-md border border-slate-200 bg-white p-0.5">
      <button
        type="button"
        className={isToday ? BTN_CHIP_ACTIVE : BTN_CHIP}
        onClick={() => onChange(today)}
      >
        Today
      </button>
      <button
        type="button"
        className={isYesterday ? BTN_CHIP_ACTIVE : BTN_CHIP}
        onClick={() => onChange(yesterday)}
      >
        Yesterday
      </button>
      <input
        type="date"
        value={date}
        onChange={(e) => onChange(e.target.value)}
        className="daily-report-date-input rounded-md border-0 bg-transparent px-2 py-1 text-xs text-slate-600 outline-none"
      />
    </div>
  );
}

export default DateQuickPicker;
